module.exports = __webpack_public_path__ + "img/orange.b80d5e3c.jpg";